import { InjectionToken } from '@angular/core';

export interface IIqTrackingStateService {}

export const TRACKING_SEGMENT_KEY = new InjectionToken<string>(
    'Tracking Segment  Key',
    {
        providedIn: 'root',
        factory: () => '',
    },
);
